import { supabase } from './supabaseClient'

export type InjuryStatus = 'NONE' | 'DISCOMFORT' | 'ACUTE'

export async function toggleExerciseComplete(exerciseId: string, completed: boolean): Promise<{ error: string | null }> {
  const { error } = await supabase.from('training_block_exercises').update({ is_completed: completed }).eq('id', exerciseId)
  return { error: error?.message ?? null }
}

export async function saveWorkoutFeedback(
  userId: string,
  scheduleId: string,
  feedback: { sessionRpe: number; injuryStatus: InjuryStatus },
): Promise<{ error: string | null }> {
  const { error } = await supabase.from('workout_session_feedback').insert({
    user_id: userId,
    schedule_id: scheduleId,
    session_rpe: feedback.sessionRpe,
    injury_status: feedback.injuryStatus,
  })

  return { error: error?.message ?? null }
}

export async function resetWorkoutExercises(exerciseIds: string[]): Promise<{ error: string | null }> {
  if (exerciseIds.length === 0) return { error: null }
  const { error } = await supabase.from('training_block_exercises').update({ is_completed: false }).in('id', exerciseIds)
  return { error: error?.message ?? null }
}
